import Relatorio from './Relatorio.vue';
import Rubricas from './componentes/Rubricas.vue';
import Lancamentos from './componentes/Lancamentos.vue';
import ControleItem from './componentes/ControleItem.vue';

export default {
  path: '/acesso-especial/relatorio',
  component: Relatorio,
  meta: { auth: true },
  children: [
    {
      path: 'rubricas',
      component: Rubricas,
      name: 'acesso-especial-relatorio.rubricas'
    },
    {
      path: 'lancamentos',
      component: Lancamentos,
      name: 'acesso-especial-relatorio.lancamentos'
    },
    {
      path: 'controle-item',
      component: ControleItem,
      name: 'acesso-especial-relatorio.controle-item'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/acesso-especial/relatorio/rotas.js